import React, { useState } from 'react';

import "./Extra.css";
import {HiLocationMarker} from 'react-icons/hi';
import CountUp from 'react-countup';




function Extra() {

  const [query, setQuery] = useState('');
  const cities = ['Delhi', 'Mumbai', 'Bangalore', 'Chennai', 'Pune', 'Hyderabad','Varanasi','Chandigarh','Bhopal','jaipur','kolkatta'];
  const filtered = cities.filter(city =>
    city.toLowerCase().includes(query.toLowerCase())
  ); 

  return (
    <>
   <section className="extra-wrapper">
    <div className="extra-container">
      <div className="title">
      <div className="extra-title">
      <h1>Discover Most <br />Perfect Properties </h1>
      {/* <div className="extra-des">
     Find Beautiful Properties that 
     suits you and explore without any difficulty!   
     </div> */}    
    </div>
    

      <span className="image-container">
     <img src="./main2.jpg" alt="mainn" />
      
     </span> 
      </div>
    
     <span className='search'>
     <p>Enter Location</p>
     <span className="search-bar">
        <HiLocationMarker color="red" size={40} >
        </HiLocationMarker>

        <input type="text" value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="Search city" />
            <button className="button">Search</button>
    </span>

    {query && (
              <ul>
                {filtered.map((city, idx) => (
                  <li key={idx} onClick={() => setQuery(city)}>
                    {city}
                  </li>
                ))}
              </ul>
            )}

      </span> 
    
    <div className="stats">
    <span>
      <CountUp start={450} end={950} duration={4.5} />
    <span> + </span>{"Happy Customers"} </span>
    
    

    <span>
      <CountUp start={1500} end={3000} duration={5} />
    <span> + </span>{"Premium Properties"} </span>   

    <span>
      <CountUp start={6} end={45} duration={4} />
    <span> + </span>{"Award Winning"} </span>
       

    </div>


    </div>
   </section>
   </>
  );
}

export default Extra
